<template>
  <div class="modal-card" style="width: 900px">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <translate>Export.header</translate>
      </p>
    </header>
    <section class="modal-card-body">
      <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
      <translate>Export.infotext</translate>
      <fob-entity-create-form v-if="!loading && !sent"
        ref="fobEntityCreateForm"
        @custom="(val) => customEvent(currentOrga, val)"
        @update:invalid="value => isInvalid = value"
        :schema="schema"
        :showErrors="showErrors"
        v-model="resourceData"
      ></fob-entity-create-form>
      <div v-if="sent" style="margin-top: 1em">
        {{ message }}
        <br>
        <b-input 
          v-if="error" 
          type="text" 
          :value="error" 
          readonly  
          style="margin: 30px 0px; width: 300px;"
        ></b-input>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button v-if="!sent" class="button" type="button" @click="$parent.close()">
        <translate>
          Export.close
        </translate>
      </button> 
      <button v-if="!sent" class="button is-primary" @click="requestExport" >
          <translate>
            Export.continue
        </translate>
      </button>
      <button v-if="sent" class="button" type="button" @click="$parent.close()">
        <translate>
          Export.close
        </translate>
      </button> 
    </footer>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import EntityCreateForm from '@/components/form/EntityCreateForm'
import { ToastError } from '@/utils'
import api from '@/api'
import exportSchema from '@/schema/list/Export'

export default {
  name: 'fob-public-list-export',
  data () {
    return {
      data: null,
      loading: true,
      showErrors: false,
      isInvalid: false,
      currentOrga: null,
      resourceData: {
        jahr: null,
        email: null,
        organisationseinheit: null
      },
      sent: false,
      message: '',
      error: null,
      schema: exportSchema
    }
  },
  methods: {
    customEvent (orga, val) {
      if (val.name === 'current-orga') {
        this.resourceData['organisationseinheit'] = orga
      }
    },
    requestExport () {
      if (this.isInvalid) {
        this.showErrors = true
        ToastError(this.$gettext(`toast.validation.failed`))
      } else {
        api.leurisExport.requestExport(
          parseInt(this.resourceData['jahr']),
          this.resourceData['organisationseinheit']._id,
          this.resourceData['email'],
          this.resourceData['format'])
        .then(() => {
          this.message = this.$gettext(`Export.success`)
          this.sent = true
        })
        .catch((error) => {
          this.message = this.$gettext(`Export.error`)
          this.error = error
          this.sent = true
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedOrganisationalUnit: 'tree/selected',
      email: 'user/email'
    })
  },
  components: {
    'fob-entity-create-form': EntityCreateForm
  },
  mounted () {
    this.resourceData['jahr'] = new Date().getFullYear()
    this.resourceData['email'] = this.email
    this.resourceData['format'] = 'PDF'

    api.methods.fetchResource('organisationseinheit', this.selectedOrganisationalUnit.id)
    .then((data) => {
      this.currentOrga = data
      this.loading = false
    })
  }
}
</script>

<style scoped lang="scss">
/deep/ .modal-card-body {
  .formfields-item {
    margin-bottom: -0.5em !important;
  }
}

.modal-card-body {
  padding-right: 2em !important;
  padding-bottom: 2em;
}

.modal-card-body /deep/ .field h3.label {
  margin-top: 25px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/public/PublicListExport.vue